<template>
	<div>
		<Header/>
		<div class="content-container">
			<div class="row" v-if="tituloCancelamento == null">
				<div class="col-12">
					<h3 class="text-primary">Cancelamento de protesto</h3>
					<p>Digite abaixo o CPF ou CNPJ do devedor que deseja cancelar o protesto e clique em PESQUISAR</p>
					<p>Se houver autorização de cancelamento dada eletronicamente pelo credor, cancele o Protesto diretamente pelo site sem a necessidade de enviar documentos originais digitalizados para o Cartório.</p>
				</div>
			</div>
			<div class="row" v-if="tituloCancelamento == null">
				<div class="col-12">
					<div class="mt-4 d-none d-xl-block container-consultas">
			            <div class="container-consultas-column">
			                <span>Pesquisar CPF/CNPJ</span>
			                <div class="boxInput">
			                    <the-mask id="input_cpf_cnpj"  :mask="['###.###.###-##', '##.###.###/####-##']" placeholder="CPF/CNPJ" v-model="cpf_cnpj" pattern="\d*" />
			                    <div class="div_bt_consultar col-3">
			                        
			                        <button type="button" class="bt-consultar"  @click="consulta()">PESQUISAR</button>
			                    </div>
			                </div>
			                
			            </div>
			        </div>
				</div>
				<div class="col-12">
					<table class="table" v-if="result.qtdTitulos > 0">
						<thead>
							<tr>
								<th>Cartório</th>
								<th>Cidade</th>
								<th>Qtd. de títulos</th>
								<th>Período da pesquisa</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="r in result.cartorio[0].dadosCartorio">
								<td>{{r.nomeCartorio}}</td>
								<td>{{r.cidade}}</td>
								<td>{{r.qtdTitulos}}</td>
								<td>5 anos</td>
								<td><button class="btn btn-primary" @click="tituloCancelamento = r">Cancelar</button></td>
							</tr>
						</tbody>
					</table>
					<p v-if="result.qtdTitulos == 0 && result.dataConsulta != null">Sem resultados para o documento pesquisado</p>
				</div>
			</div>
			<div style="display:none;">{{erros}}</div>
			<div class="row" v-if="tituloCancelamento != null && erros.length > 0">
				<div class="col-12">
					<div class="alert alert-warning">
						<div class="row">
							<div class="col-10">
								<p class="text" v-for="m in erros"> {{m}}</p>
							</div>
							<div class="col-2">
								<a href="#" class="float-right" @click="erros = [];">x</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="tituloCancelamento != null && passo == 1">
				<div class="col-12">
					<div class="card p-5">
						<h5 class="text-danger text-center"><i class="fa fa-info-circle" aria-hidden="true"></i> IMPORTANTE</h5>
						<p><b>O prazo para o envio do pedido para o cartório competente e a efetivação do cancelamento é de 3 a 5 dias úteis.</b> Os cancelamentos somente serão feitos após a comprovação pelo banco do pagamento efetuado</p>
						<p>
							A informação do protesto cancelado é enviada para as entidades de proteção ao crédito (SERASA, Boa Vista, etc.) pelo próprio cartório. <b>A CENPROT não é responsável pelo envio dessa informação e apenas faz o repasse dos pedidos de cancelamento para os cartórios competentes.</b>
						</p>
						<p>Esclarecemos também que, tanto a CENPROT como os cartórios, não possuem qualquer acesso ao banco de dados dessas entidades (SERASA, Boa Vista, etc).</p>
						<p>
							Qualquer restrição que ainda conste no SERASA, Boa Vista, etc, após os prazos legais, <b>deverão ser questionados diretamente com o órgão de proteção de crédito </b>no qual constar eventual restrição relativa a protestos já cancelados.
						</p>
					</div>
					<br>
				</div>
				<div class="col-12">
					<p>Informe seus dados para receber o boleto ou o comprovante</p>
				</div>
				<div class="col-6 col-md-4">
					<div class="form-group">
						<label>Email</label>
					    <input type="email" class="form-control" placeholder="Por favor, informe seu email" v-model="form.email">
					</div>
				</div>
				<div class="col-6 col-md-4">
					<div class="form-group">
						<label>Confirmar email</label>
					    <input type="email" class="form-control" placeholder="Por favor, digite novamente o seu email" v-model="confirmEmail">
					</div>
				</div>
				<div class="col-6 col-md-4">
					<div class="form-group">
						<label>Emitir cobrança em nome de:</label>
					    <select class="form-control" v-model="form.tipo_pessoa">
						  	<option value="0">Selecione</option>
						  	<option value="1">Pessoa física</option>
						  	<option value="2">Pessoa jurídica</option>
						</select>
					</div>
				</div>
				<div class="col-12">
					<button class="btn btn-success btn-lg float-right" @click="proximo(2)">Próximo</button>
					<span class="float-right">&nbsp;</span>
					<button class="btn btn-primary float-right" @click="tituloCancelamento = null">Voltar</button>
				</div>
			</div>
			<div class="row" v-if="tituloCancelamento != null && passo == 2">
				<div class="col-6">
					<div class="form-group">
						<label>Nome</label>
					    <input type="text" class="form-control" placeholder="Por favor, digite o nome" v-model="form.nome">
					</div>
				</div>
				<div class="col-3">
					<div class="form-group">
						<label>CPF do solicitante</label>
					    <input type="text" class="form-control" placeholder="CPF" v-model="form.cpf">
					</div>
				</div>
				<div class="col-3">
					<div class="form-group">
						<label>Celular</label>
					    <input type="text" class="form-control" placeholder="Celular" v-model="form.celular">
					</div>
				</div>
				<div class="col-3">
					<div class="form-group">
						<label>CEP</label>
					    <input type="text" class="form-control" placeholder="CEP" v-model="form.cep">
					</div>
				</div>
				<div class="col-3">
					<div class="form-group">
						<label>Estado:</label>
					    <select class="form-control" v-model="form.uf">
						  	<option value="AC">Acre</option>
						  	<option value="AL">Alagoas</option>
						  	<option value="AP">Amapá</option>
						  	<option value="AM">Amazonas</option>
						  	<option value="BA">Bahia</option>
						  	<option value="CE">Ceará</option>
						  	<option value="DF">Distrito Federal</option>
						  	<option value="ES">Espírito Santo</option>
						  	<option value="GO">Goias</option>
						  	<option value="MA">Maranhão</option>
						  	<option value="MT">Mato Grosso</option>
						  	<option value="MS">Mato Grosso do Sul</option>
						  	<option value="MG">Minas Gerais</option>
						  	<option value="PA">Pará</option>
						  	<option value="PB">Paraíba</option>
						  	<option value="PR">Paraná</option>
						  	<option value="PE">Pernambuco</option>
						  	<option value="PI">Piauí</option>
						  	<option value="RJ">Rio de Janeiro</option>
						  	<option value="RN">Rio Grande do Norte</option>
						  	<option value="RS">Rio Grande do Sul</option>
						  	<option value="RO">Rondônia</option>
						  	<option value="RR">Roraima</option>
						  	<option value="SC">Santa Catarina</option>
						  	<option value="SP">São Paulo</option>
						  	<option value="SE">Sergipe</option>
						  	<option value="TO">Tocantins</option>
						</select>
					</div>
				</div>
				<div class="col-3">
					<div class="form-group">
						<label>Cidade:</label>
					    <input type="text" class="form-control" placeholder="Endereço" v-model="form.cidade">
					</div>
				</div>
				<div class="col-6">
					<div class="form-group">
						<label>Endereço:</label>
					    <input type="text" class="form-control" placeholder="Endereço" v-model="form.endereco">
					</div>
				</div>
				<div class="col-6">
					<div class="form-group">
						<label>Complemento:</label>
					    <input type="text" class="form-control" placeholder="complemento" v-model="form.complemento">
					</div>
				</div>
				<div class="col-6">
					<div class="form-group">
						<label>Bairro:</label>
					    <input type="text" class="form-control" placeholder="complemento" v-model="form.bairro">
					</div>
				</div>
				<div class="col-12">
					<button class="btn btn-success btn-lg float-right" @click="proximo(3)">Próximo</button>
					<span class="float-right">&nbsp;</span>
					<button class="btn btn-primary float-right" @click="passo = 1">Voltar</button>
				</div>
			</div>
			<div class="row" v-if="tituloCancelamento != null && passo == 3">
				<div class="col-12">
					<p>Para concluir seu pedido, efetue o pagamento escolhendo uma das opções ao final desta tela. Após a confirmação do pagamento, as solicitações serão direcionadas para os cartórios competentes para processamento dos títulos quitados.</p>

					<p>O prazo para confirmação do pagamento varia conforme a forma de pagamento.</p>

					<p>Para a opção boleto, o não pagamento até a data de vencimento ou pagamento com valor divergente cancelará o pedido.</p>
				</div>
				<div class="col-6">
					<button class="btn btn-lg" @click="tipo_pagamento = 1">
						<img src="~@/assets/imgs/pix-logo.png" style="width: 200px;">
					</button>
					<button class="btn btn-lg" @click="tipo_pagamento = 2">
						<img src="~@/assets/imgs/image-boleto.jpg" style="width: 200px;">
					</button>
				</div>
				<div class="col-6" v-if="tipo_pagamento == 2">
					<div class="form-group">
						<label>Emitir boleto em nome de:</label>
						<select class="form-control">
							<option value="1">Solicitante</option>
							<option value="2">Devedor</option>
						</select>
					</div>
				</div>
				<div class="col-12">
					<button class="btn btn-success btn-lg float-right" @click="finalizar()">Gerar Pagamento</button>
					<span class="float-right">&nbsp;</span>
					<button class="btn btn-primary float-right" @click="passo = 2">Voltar</button>
				</div>
			</div>
			<div class="row" v-if="tituloCancelamento != null && passo == 4">
				<div class="col-12">
					<h5>Você receberá um token por email e sms, por favor, digite abaixo para validar!</h5>
				</div>
				<div class="col-3">
					<div class="form-group">
						<input type="text" class="form-control" v-model="token">
					</div>
				</div>
				<div class="col-3">
					<button class="btn btn-lg btn-primary">Validar</button>
				</div>
			</div>
			<div class="md-msg" v-if="msg != null">
				<p><span>Falha ao realizar consulta</span></p>
				<button class="btn btn-primary" @click="msg = null;">Fechar</button>
			</div>
		</div>
	</div>
</template>
<script>
	import Header from '../../components/Header';
	import { TheMask } from "vue-the-mask";
	import API from '../../services/api'
	export default {
		components: {
		    Header,
		    TheMask
		},
		data() {
			return {
				cpf_cnpj: null,
				result: {qtdTitulos: 0, dataConsulta: null},
				msg: null,
				tituloCancelamento: null,
				tipo_pagamento: null,
				confirmEmail: null,
				form: {
					email: null,
					tipo_pessoa: 0,
				},
				passo: 1,
				erros: [
				],
			}
		},
		methods: {
			consulta() {
				this.result = {qtdTitulos: 0, dataConsulta: null};
				API.get(`consultasimples/${this.cpf_cnpj}`).then((res) => {
					this.result = res.data;
				})
			},
			proximo(c) {
				this.erros = [];
				if(c == 2) {
					if(this.form.email == null || this.form.email.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo email corretamente');
						console.log(this.erros);
						this.$nextTick()
						return
					}
					if(this.form.email != this.confirmEmail) {
						this.erros.push('Emails digitados não conferem');
						this.$nextTick()
						return
					}
				}
				if(c == 3) {
					if(this.form.nome == null || this.form.nome.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo nome corretamente');
						this.$nextTick()
						return
					}
					if(this.form.cpf == null || this.form.cpf.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo cpf corretamente');
						this.$nextTick()
						return
					}
					if(this.form.celular == null || this.form.celular.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo celular corretamente');
						this.$nextTick()
						return
					}
					if(this.form.cep == null || this.form.cep.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo cep corretamente');
						this.$nextTick()
						return
					}
					if(this.form.uf == null || this.form.uf.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo uf corretamente');
						this.$nextTick()
						return
					}
					if(this.form.cidade == null || this.form.cidade.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo uf corretamente');
						this.$nextTick()
						return
					}
					if(this.form.endereco == null || this.form.endereco.replaceAll(' ', '') == '') {
						this.erros.push('Preencha o campo uf corretamente');
						this.$nextTick()
						return
					}
				}

				this.passo = c;
			},
			finalizar() {
				if(this.tipo_pagamento == null) {
					this.erros.push('Selecione a forma de pagamento');
						this.$nextTick()
						return
				}
				this.passo = 4;
			}
		}
	};
</script>
<style scoped>
	#cancelamento {
		width: 900px;
	}
	.md-msg {
		padding: 10px;
		width: 250px;
		height: 120px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -125px;
		margin-left: -60px;
		text-align: center;
		border: 1px solid #CCCCCC;
		border-radius: 5px;
	}
	.bt-consultar {
		width: 110px !important;
		padding: 5px;
	}
	@media (max-width: 1200px) {
	  #cancelamento {
	    margin-top: 68px;
	    margin-bottom: 0px;
	    padding-bottom: 0px;
	  }
	}
</style>